"use client";

import Separator from "@/app/(components)/generics/Separator/Separator";
import { TKey } from "@/app/translations/TKey";
import { PlanSettings } from "@/app/types/billing/PlanSettings";
import { PageProps } from "@/app/types/common/PageProps";
import { UWallet } from "@/app/utils/UWallet";
import { Credits } from "@/app/vars/Credits";
import CallToCTA from "../components/CallToCTA/CallToCTA";
import ConceptFlow from "../components/ConceptFlow/ConceptFlow";
import FAQ from "../components/FAQ/FAQ";
import { MEIDLY_FAQ } from "../components/FAQ/FAQ.logic";
import FlowBeam from "../components/FlowBeam/FlowBeam";
import ForWho from "../components/ForWho/ForWho";
import Hero from "../components/Hero/Hero";
import Layout from "../components/Layout/Layout";
import Pricing from "../components/Pricing/Pricing";
import SectionArrow from "../components/SectionArrow/SectionArrow";
import TheJourney from "../components/TheJourney/TheJourney";
import Tools from "../components/Tools/Tools";
import WhyMeidly from "../components/WhyMeidly/WhyMeidly";
import styles from "../Home.module.css";
import { MeidlyToolsData } from "./MeidlyToolsData";

type Props = PageProps & {
  plan: PlanSettings;
};

export default function Meidly(props: Props) {
  return (
    <Layout>
      <div className={styles.content}>
        <Hero
          params={props.params}
          freeHours={UWallet.hoursFromCredits(Credits.FREE_CALL_CREDITS)}
          keys={{
            supTitle: TKey.HOME_MEIDLY_HERO_SUP_TITLE,
            secondaryCta: TKey.HOME_MEIDLY_HERO_SECONDARY_CTA,
            pricing: TKey.HOME_MEIDLY_HERO_PRICING,
            title1: TKey.HOME_MEIDLY_HERO_TITLE_1,
            title2: TKey.HOME_MEIDLY_HERO_TITLE_2,
            title3_1: TKey.HOME_MEIDLY_HERO_TITLE_3_1,
            title3_2: TKey.HOME_MEIDLY_HERO_TITLE_3_2,
            title3_3: TKey.HOME_MEIDLY_HERO_TITLE_3_3,
            title3_4: TKey.HOME_MEIDLY_HERO_TITLE_3_4,
            text1: TKey.HOME_MEIDLY_HERO_TEXT_1,
            text2: TKey.HOME_MEIDLY_HERO_TEXT_2,
          }}
        />
      </div>

      <SectionArrow />

      <div className={styles.content}>
        <ConceptFlow params={props.params} />
      </div>

      <div className={`${styles.content} ${styles.scrollTarget}`} id="principe">
        <div className={`${styles.scrollTarget}`} id="why">
          <WhyMeidly />
        </div>

        <TheJourney
          params={props.params}
          keys={[
            {
              title: TKey.HOME_MEIDLY_JOURNEY_1_TITLE,
              text: TKey.HOME_MEIDLY_JOURNEY_1_TEXT,
            },
            {
              title: TKey.HOME_MEIDLY_JOURNEY_2_TITLE,
              text: TKey.HOME_MEIDLY_JOURNEY_2_TEXT,
            },
            {
              title: TKey.HOME_MEIDLY_JOURNEY_3_TITLE,
              text: TKey.HOME_MEIDLY_JOURNEY_3_TEXT,
            },
            {
              title: TKey.HOME_MEIDLY_JOURNEY_4_TITLE,
              text: TKey.HOME_MEIDLY_JOURNEY_4_TEXT,
            },
          ]}
        />
      </div>

      <FlowBeam streams={9} />

      <div className={`${styles.content} ${styles.scrollTarget}`} id="who">
        <ForWho />
      </div>

      <Separator />

      <div className={styles.content}>
        <Tools
          params={props.params}
          phases={MeidlyToolsData}
          keys={{
            supTitle: TKey.HOME_MEIDLY_TOOLS_SUP_TITLE,
            title: TKey.HOME_MEIDLY_TOOLS_TITLE,
            introText: TKey.HOME_MEIDLY_TOOLS_INTRO_TEXT,
            checks: [
              {
                title: TKey.HOME_MEIDLY_TOOLS_CHECK_1,
                text: TKey.HOME_MEIDLY_TOOLS_CHECK_1_TEXT,
              },
              {
                title: TKey.HOME_MEIDLY_TOOLS_CHECK_2,
                text: TKey.HOME_MEIDLY_TOOLS_CHECK_2_TEXT,
              },
              {
                title: TKey.HOME_MEIDLY_TOOLS_CHECK_3,
                text: TKey.HOME_MEIDLY_TOOLS_CHECK_3_TEXT,
              },
            ],
            flagship: TKey.HOME_MEIDLY_TOOLS_FLAGSHIP,
            upcoming: TKey.HOME_MEIDLY_TOOLS_UPCOMING,
            btnAccess: TKey.HOME_MEIDLY_TOOLS_BTN_ACCESS,
            btnNotify: TKey.HOME_MEIDLY_TOOLS_BTN_NOTIFY,
          }}
        />
      </div>

      <div className={`${styles.content} ${styles.scrollTarget}`} id="tarifs">
        <Pricing params={props.params} plan={props.plan} />
      </div>

      <div className={`${styles.content} ${styles.scrollTarget}`} id="faq">
        <FAQ params={props.params} keys={MEIDLY_FAQ} />
      </div>

      <div className={styles.content}>
        <CallToCTA
          params={props.params}
          keys={{
            title1: TKey.HOME_MEIDLY_CTA_TITLE_1,
            title2: TKey.HOME_MEIDLY_CTA_TITLE_2,
            title3: TKey.HOME_MEIDLY_CTA_TITLE_3,
            btn: TKey.HOME_MEIDLY_CTA_BTN,
          }}
        />
      </div>
    </Layout>
  );
}
